export default __webpack_public_path__ + "static/media/intro_box.29a7be86.png";